import React, { useEffect, useContext, useState, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AppContext, DispatchContext } from "../AppContext";
import Service from "../services/service";
import * as actions from "../actions/actions";
import { toggleCaptcha, config, resolveNotificationMessage } from '../helpers/constants';
import { List, ListItem, ListItemIcon, ListItemText, Button, Typography, FormControl, InputLabel, Select, MenuItem, Grid } from "@material-ui/core";
import PriceCard from './PriceCard';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';


const useStyles = makeStyles((theme) => ({
  paper: {
    width: 850,
    minHeight: 600,
    position: "relative",
    boxShadow: "0px 0px 5px 5px rgba(0, 0, 0, 0.25)",
    "&:hover": {
      boxShadow: "0px 0px 7px 7px rgba(0, 0, 0, 0.4)",
      transition: "box-shadow 0.3s ease-in-out",
    }
  }
}));

export default function WizardSelectProductPanel(props) {
  const dispatch = useContext(DispatchContext);
  const state = useContext(AppContext);
  const s = state.strings;
  const classes = useStyles();


  const onOkButtonClicked = () => {
    dispatch(actions.showFullscreenLoading(true, s.loginDialog.creatingGuestAccount));
    captchaAction("wizardLogin", doGuestLogin);
  }

  
  const captchaAction = (action, fn) => {
    const captchas = document.getElementsByClassName("grecaptcha-badge");
    if (captchas.length > 0 && captchas[0].style.visibility != "hidden") {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(config.captchaKey, { action: action }).then(function (token) {
          Service.verifyReCaptcha(token).then((verifyRes) => {
            if (verifyRes.success) {
              fn();
            } else {
              dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(verifyRes.errors[0], s.notificationMessage) }));
            }
          });
        });
      });
    } else {
      fn();
    }
  }

  const doGuestLogin = () => {
    Service.createGuestUser().then(res => {
      if (res.success) {
        Service.getUserInfo().then(getInfoRes => {
          dispatch(actions.setUserDetails(getInfoRes.data));
          dispatch(actions.showFullscreenLoading(false));
        });
      } else {
        dispatch(actions.openToast({ type: "error", message: res.errors[0], status: true }));
        dispatch(actions.showFullscreenLoading(false));
      }
    });
  }


  return (
    <div style={{ width: 500, marginLeft: 175, display: "flex", flexDirection: "column", alignItems: "center" }}>
      <Typography color="primary" variant="h6">{s.wizard.welcome}</Typography>
      <List dense={false}>
        <ListItem>
          <ListItemIcon><CheckCircleOutlineIcon /></ListItemIcon>
          <ListItemText
            primary={s.wizard.professionalPerfomance}
            secondary={s.wizard.usedByOrgs}
          />
        </ListItem>

        <ListItem>
          <ListItemIcon><CheckCircleOutlineIcon /></ListItemIcon>
          <ListItemText
            primary={s.wizard.dataProtection}
            secondary={s.wizard.notShared}
          />
        </ListItem>
        <ListItem>
          <ListItemIcon><CheckCircleOutlineIcon /></ListItemIcon>
          <ListItemText
            primary={s.wizard.tryFree}
            secondary={s.wizard.upToPages}
          />
        </ListItem>
      </List>

      <Button color="primary" variant="contained" onClick={onOkButtonClicked}>{s.wizard.getStarted}</Button>
    </div>
  );
}
